export default __webpack_public_path__ + "static/media/Scholarship.f11dbd3e.png";